import { ButtonHTMLAttributes, forwardRef, MouseEventHandler } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export type IButtonColor = "primary" | "secondary" | "error";

interface Props {
  label?: string;
  icon?: IconDefinition;
  iconEnd?: IconDefinition;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  solid?: boolean;
  outlined?: boolean;
  active?: boolean;
  color?: IButtonColor;
  size?: "xs" | "s" | "m" | "l";
  className?: string;
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      icon,
      iconEnd,
      onClick,
      disabled,
      solid = true,
      outlined,
      active,
      color = "primary",
      size = "s",
      className,
      buttonProps,
    },
    ref
  ) => (
    <button
      ref={ref}
      disabled={disabled}
      className={clsx("btn", className, color, size, {
        solid,
        outlined,
        active,
      })}
      onClick={onClick}
      type={buttonProps?.type || onClick ? "button" : "submit"}
      {...buttonProps}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      {label && <div className="btn-label">{label}</div>}
      {iconEnd && <FontAwesomeIcon icon={iconEnd} />}
    </button>
  )
);
